import React from 'react';
import styled from 'styled-components';
import { BaseConfetti } from 'elements/confetti/confetti.styles'
import { layout } from 'styles/layout'

export const Confetti1 = styled(BaseConfetti).attrs({
  width: 22,
  height: 35,
  viewBox: '0 0 22 35',
  children: <path xmlns="http://www.w3.org/2000/svg" d="M4.57873 16.8382L16.2505 32.4451L20.5982 5.33772L4.57873 16.8382Z" stroke="#E7B556" strokeWidth="2" />
})`
  top: -2%;
  left: 3%;
  width: 16px;

  @media all and (min-width: ${layout.sm}) {
    top: 6%;
    left: 5%;
    width: 22px;
  }

  @media all and (min-width: ${layout.subLg}) {
    top: 30%;
    left: 5%;
  }
`

export const Confetti2 =  styled(BaseConfetti).attrs({
  width: 27,
  height: 34,
  viewBox: '0 0 27 34',
  children: <path xmlns="http://www.w3.org/2000/svg" opacity="0.6" d="M2 7.49683L13.6027 1.99988L25.3295 26.7522L7.99891 20.159L2 7.49683Z" stroke="#89026C" strokeWidth="2" strokeLinejoin="round" />
})`
  top: 1%;
  right: 3%;
  transform: rotate(-120deg);
  width: 19px;

  @media all and (min-width: ${layout.sm}) {
    top: 7%;
    right: 5%;
    width: 27px;
    transform: rotate(-120deg);
  }

  @media all and (min-width: ${layout.subLg}) {
    top: 30%;
    right: 15%;
    transform: initial;
    width: 27px;
  }
`

export const Confetti3 =  styled(BaseConfetti).attrs({
  width: 25,
  height: 27,
  viewBox: '0 0 25 27',
  children: <path d="M21.7139 26.8948L24.6127 10.7408L19.2498 2.95779L3.18219 -5.57008e-05L0.223875 16.0674L5.58668 23.8504L21.7139 26.8948Z" fill="#80D1CD" />
})`
  bottom: 43%;
  left: 5%;
  width: 14px;

  @media all and (min-width: ${layout.sm}) {
    bottom: 18%;
    left: 5%;
    width: 25px;
  }

  @media all and (min-width: ${layout.subLg}) {
    bottom: 30%;
    left: 20%;
    width: 25px;
  }
`
